import React from 'react'
import { MenuLink } from '../../../core/until'
import { translate } from '../../../core'
import { Badge, Space } from 'antd'
import { useQuery } from '@apollo/client'
import { GetNewAppointmentCountQuery } from '../graphql/appointment.graphql'
import { ShowIf } from '../../../core/component'
import { ScheduleOutlined } from '@ant-design/icons'

export const useNewAppointmentCount = () => {
  const {data} = useQuery(GetNewAppointmentCountQuery)
  return {newAppointmentCount: data?.appointmentsNewCount ?? 0}
}

export const AppointmentMenuItem = () => {
  const {newAppointmentCount} = useNewAppointmentCount()

  return (
    <Space>
      <MenuLink
        title={translate('appointments')}
        to='/appointments'
      />
      <ShowIf
        condition={!!newAppointmentCount}
        replacement={<></>}
      >
        <Badge count={newAppointmentCount} color='#f5222d'/>
      </ShowIf>
    </Space>
  )
}

export const AppointmentMenuIcon = () => {
  const {newAppointmentCount} = useNewAppointmentCount()

  return (
    <>
      {newAppointmentCount > 0 ? (
        <ScheduleOutlined style={{fontSize: 23, color: "#f5222d"}}/>
      ) : (
        <ScheduleOutlined style={{fontSize: 23, color: "#a3bde3"}}/>
      )}
    </>
  )
}
